import { createAction } from '@src/redux/helpers/createAction';
import { submitTINRequestSaga } from './sagas';

import {
  SELECT_ADMIN,
  SET_UNKNOWN_PAA,
  RESET_STATE,
  SET_PHONE_NUMBER,
  SET_JOB_FUNCTIONS,
  SUBMIT_TIN_REQUEST,
  SET_PERMISSIONS,
} from './constants';

export const selectAdmin = (payload) => {
  return createAction({
    type: SELECT_ADMIN,
    payload,
  });
};

export const setJobFunctions = (payload) => {
  return createAction({
    type: SET_JOB_FUNCTIONS,
    payload,
  });
};

export const setUnknownPAA = (payload) => {
  return createAction({
    type: SET_UNKNOWN_PAA,
    payload,
  });
};

export const setPhoneNumber = (payload) => {
  return createAction({
    type: SET_PHONE_NUMBER,
    payload,
  });
};

export const resetState = (payload) => {
  return createAction({
    type: RESET_STATE,
    payload,
  });
};

export const submitTINRequest = (req, onSuccess, onError) => {
  return createAction({
    type: SUBMIT_TIN_REQUEST,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: submitTINRequestSaga,
    },
  });
};

export const setPermissions = (payload) => {
  return createAction({
    type: SET_PERMISSIONS,
    payload,
  });
};
